import prescriptionOZPService from '../services/apiRequests/prescription_ozp.service';

export default {
    namespaced: true,
    state: {
        ObjectHouseList: [],
        ObjectHouseListLength: 0,
        ObjectHousePagination: null,
        ObjectHouseLoading: false,
        PrescriptionOZPList: [],
        PrescriptionOZPListLength: 0,
        PrescriptionOZPPagination: null,
        PrescriptionOZPLoading: false,
        ReqList: [],
        ReqListLength: 0,
        ReqPagination: null,
        ReqLoading: false,
        EventTypeList: [],
        PrescriptionInfo: {},
        paramSaved: null,
        prescriptionOZPStatusTypes: [],
        EngineerKSKHousesList: [],
        EngineerContractsList: [],
        ReqContractsList: [],
        EngineerObjectsList: [],
        PeriodsList: [],
        KSKList: { ksk: [] },
        EngineerObjectContractsList: [],
        iengineer_rid: null,
        ConsumptionCategoryList: []
    },
    mutations: {
        setiengineer_rid(state, iengineer_rid) {
            state.iengineer_rid = iengineer_rid;
        },
        setEngineerObjectContractsList(state, EngineerObjectContractsList) {
            state.EngineerObjectContractsList = EngineerObjectContractsList;
        },
        setEngineerContractsList(state, EngineerContractsList) {
            state.EngineerContractsList = EngineerContractsList;
        },
        setReqContractsList(state, ReqContractsList) {
            state.ReqContractsList = ReqContractsList;
        },
        setEngineerObjectsList(state, EngineerObjectsList) {
            state.EngineerObjectsList = EngineerObjectsList;
        },
        setPeriodsList(state, PeriodsList) {
            state.PeriodsList = PeriodsList;
        },
        setKSKList(state, KSKList) {
            state.KSKList = KSKList;
        },
        setEngineerKSKHousesList(state, EngineerKSKHousesList) {
            state.EngineerKSKHousesList = EngineerKSKHousesList;
        },
        setprescriptionOZPStatusTypes(state, prescriptionOZPStatusTypes) {
            state.prescriptionOZPStatusTypes = prescriptionOZPStatusTypes;
        },
        setparamSaved(state, paramSaved) {
            state.paramSaved = paramSaved;
        },
        setPrescriptionOZPInfo(state, PrescriptionOZPInfo) {
            state.PrescriptionOZPInfo = PrescriptionOZPInfo;
        },
        setEventTypeList(state, EventTypeList) {
            state.EventTypeList = EventTypeList;
        },
        setObjectHouseList(state, ObjectHouseList) {
            state.ObjectHouseList = ObjectHouseList;
        },
        setObjectHouseListLength(state, ObjectHouseListLength) {
            state.ObjectHouseListLength = ObjectHouseListLength;
        },
        setObjectHousePagination(state, ObjectHousePagination) {
            state.ObjectHousePagination = ObjectHousePagination;
        },
        setObjectHouseLoading(state, ObjectHouseLoading) {
            state.ObjectHouseLoading = ObjectHouseLoading;
        },
        setPrescriptionOZPList(state, PrescriptionOZPList) {
            state.PrescriptionOZPList = PrescriptionOZPList;
        },
        setPrescriptionOZPListLength(state, PrescriptionOZPListLength) {
            state.PrescriptionOZPListLength = PrescriptionOZPListLength;
        },
        setPrescriptionOZPPagination(state, PrescriptionOZPPagination) {
            state.PrescriptionOZPPagination = PrescriptionOZPPagination;
        },
        setPrescriptionOZPLoading(state, PrescriptionOZPLoading) {
            state.PrescriptionOZPLoading = PrescriptionOZPLoading;
        },
        setReqList(state, ReqList) {
            state.ReqList = ReqList;
        },
        setReqListLength(state, ReqListLength) {
            state.ReqListLength = ReqListLength;
        },
        setReqPagination(state, ReqPagination) {
            state.ReqPagination = ReqPagination;
        },
        setReqLoading(state, ReqLoading) {
            state.ReqLoading = ReqLoading;
        },
        setReqOZPInfo(state, ReqOZPInfo) {
            state.ReqOZPInfo = ReqOZPInfo;
        },
        setConsumptionCategoryList(state, payload) {
            state.ConsumptionCategoryList = payload;
        }
    },
    actions: {
        async getObjectsHouses({ commit, state }, { engineer_rid, filter, itemsPerPage, currentItem }) {
            try {
                commit('setObjectHouseList', []);
                commit('setObjectHouseListLength', 0);
                commit('setObjectHouseLoading', true);

                const where = [];

                if (filter?.contract_rid) {
                    where.push({ field: 'contract_rid', value: String(filter.contract_rid) });
                }
                if (filter?.category_rid) {
                    where.push({ field: 'category_rid', value: String(filter.category_rid) });
                }
                if (filter?.object_rid) {
                    where.push({ field: 'object_rid', value: String(filter.object_rid) });
                }
                if (filter?.address_full_name___ru) {
                    where.push({ field: 'address_full_name___ru', value: String(filter.address_full_name___ru) });
                }

                if (filter?.is_formed === 1 || filter?.is_formed === 0) {
                    where.push({ field: 'is_formed', value: String(filter.is_formed) });
                }

                const iWhereOrderLocale = {
                    engineer_rid,
                    ...(where.length ? { where } : {})
                };

                const res = await prescriptionOZPService.getObjectsHouses(itemsPerPage, currentItem, iWhereOrderLocale);

                const list = Array.isArray(res?.objects_houses) ? res.objects_houses : [];

                const rowCount = Number(res?.pagination?.row_count || list.length || 0);

                commit('setObjectHouseList', list);
                commit('setObjectHouseListLength', rowCount);

                //commit('setObjectHouseList', res.objects_houses);
                //if (res && res.pagination && res.pagination.row_count) commit('setObjectHouseListLength', res.pagination.row_count);
            } catch (e) {
                console.error(e);
            } finally {
                commit('setObjectHouseLoading', false);
            }
        },
        async getPrescriptionsOZP(
            { commit, state },
            { engineer_rid, contract_rid, ksk_rid, user_id, object_name, status_code_name, period_rid, prescription_number, boss, itemsPerPage, currentItem }
        ) {
            try {
                commit('setPrescriptionOZPList', []);
                commit('setPrescriptionOZPListLength', 0);
                commit('setPrescriptionOZPLoading', true);
                const param = {
                    engineer_rid: engineer_rid ?? state.iengineer_rid ?? null,
                    contract_rid: contract_rid ?? null,
                    period_rid: period_rid ?? null,
                    object_name: object_name ?? null,
                    ksk_rid: ksk_rid ?? null,
                    user_id: user_id ?? null,
                    boss: boss ?? 0,
                    status_code_name,
                    prescription_number
                };
                commit('setparamSaved', param);
                const res = await prescriptionOZPService.getPrescriptionsOZP(itemsPerPage, currentItem, param);
                const list = Array.isArray(res?.ahs_requests) ? res.ahs_requests : [];

                const total = Number(res?.pagination?.row_count ?? list.length);

                commit('setPrescriptionOZPList', list);
                commit('setPrescriptionOZPListLength', total);
            } catch (e) {
                console.error(e);
            } finally {
                commit('setPrescriptionOZPLoading', false);
            }
        },
        async getReqs({ commit, state }, { contract_rid, code_name, req_type_code_name, user_id, itemsPerPage, currentItem }) {
            try {
                commit('setReqList', []);
                commit('setReqListLength', 0);
                commit('setReqLoading', true);
                const normalizedCodeName = Array.isArray(code_name) && code_name.length > 0 ? code_name : null;
                const param = {
                    contract_rid: contract_rid ?? null,
                    code_name: normalizedCodeName,
                    req_type_code_name: req_type_code_name,
                    user_id: user_id
                };
                commit('setparamSaved', param);
                const res = await prescriptionOZPService.getReqs(itemsPerPage, currentItem, param);
                commit('setReqList', res.ahs_requests);
                if (res && res.pagination && res.pagination.row_count) commit('setReqListLength', res.pagination.row_count);
            } catch (e) {
                console.error(e);
            } finally {
                commit('setReqLoading', false);
            }
        },
        async getEventTypes({ commit }) {
            try {
                commit('setEventTypeList', []);
                const res = await prescriptionOZPService.getEventTypes();
                commit('setEventTypeList', res);
            } catch (e) {
                console.error(e);
            }
        },
        async getConsumptionCategory({ commit }) {
            const res = await prescriptionOZPService.getConsumptionCategory();

            commit('setConsumptionCategoryList', res);
        },
        async getPrescriptionOZPInfo({ commit }, id) {
            try {
                commit('setPrescriptionOZPInfo', {});
                const res = await prescriptionOZPService.getPrescriptionOZPInfo(id);

                commit('setPrescriptionOZPInfo', res);
                return res;
            } catch (e) {
                console.error(e);
            } finally {
                //commit('setPrescriptionLoading', false);
            }
        },
        async getReqOZPInfo({ commit }, id) {
            try {
                commit('setReqOZPInfo', {});
                const res = await prescriptionOZPService.getReqOZPInfo(id);

                commit('setReqOZPInfo', res);
                return res;
            } catch (e) {
                console.error(e);
            } finally {
                //commit('setPrescriptionLoading', false);
            }
        },
        async postPrescriptionsOZP({ commit }, { nvcPrescriptionData }) {
            return await prescriptionOZPService.postPrescriptionsOZP(nvcPrescriptionData);
        },
        async postReqOZP({ commit }, { nvcPrescriptionRequestData }) {
            return await prescriptionOZPService.postReqOZP(nvcPrescriptionRequestData);
        },
        async prescriptionOZPStatusChange({ commit }, { iPrescription_rid, iStatus_rid, comment }) {
            return await prescriptionOZPService.prescriptionOZPStatusChange(iPrescription_rid, iStatus_rid, comment);
        },
        async GetPrescriptionOZPStatusTypes({ commit }) {
            try {
                commit('setprescriptionOZPStatusTypes', []);
                const res = await prescriptionOZPService.prescriptionOZPStatusTypes();
                commit('setprescriptionOZPStatusTypes', res);
            } catch (e) {
                console.error(e);
            } finally {
                //commit('setPrescriptionLoading', false);
            }
        },
        async getEngineerKSKHousesList({ commit }, { iengineer_rid }) {
            try {
                commit('setEngineerKSKHousesList', []);
                const res = await prescriptionOZPService.getEngineerKSKHousesList(iengineer_rid);
                commit('setEngineerKSKHousesList', res.houses);
            } catch (e) {
                console.error(e);
            } finally {
                //commit('setPrescriptionLoading', false);
            }
        },
        async getEngineerContractsList({ commit }, { iengineer_rid }) {
            try {
                commit('setEngineerContractsList', []);
                const res = await prescriptionOZPService.getEngineerContractsList(iengineer_rid);
                commit('setEngineerContractsList', res?.contracts || []);
            } catch (e) {
                console.error(e);
            } finally {
                //commit('setPrescriptionLoading', false);
            }
        },
        async getReqContractsList({ commit }) {
            try {
                commit('setReqContractsList', []);
                const res = await prescriptionOZPService.getReqContractsList();
                commit('setReqContractsList', res?.contracts || []);
            } catch (e) {
                console.error(e);
            } finally {
                //commit('setPrescriptionLoading', false);
            }
        },
        async getEngineerObjectsList({ commit }, { iengineer_rid }) {
            try {
                commit('setEngineerObjectsList', []);
                const res = await prescriptionOZPService.getEngineerObjectsList(iengineer_rid);
                commit('setEngineerObjectsList', res?.contracts || []);
            } catch (e) {
                console.error(e);
            } finally {
                //commit('setPrescriptionLoading', false);
            }
        },
        async getPeriodsList({ commit }) {
            try {
                commit('setPeriodsList', []);
                const res = await prescriptionOZPService.getPeriodsList();
                commit('setPeriodsList', res || []);
            } catch (e) {
                console.error(e);
            } finally {
                //commit('setPrescriptionLoading', false);
            }
        },
        async getKSKList({ commit }) {
            try {
                commit('setKSKList', []);
                const res = await prescriptionOZPService.getKSKList();
                commit('setKSKList', res || []);
            } catch (e) {
                console.error(e);
            } finally {
                //commit('setPrescriptionLoading', false);
            }
        },
        async getPrescriptionsObjectsOZP({ commit, state }, { engineer_rid, contract_rid, ksk_rid, user_id }) {
            try {
                commit('setPrescriptionsObjectsOZP', []);

                const param = {
                    engineer_rid: engineer_rid ?? state.iengineer_rid ?? null,
                    contract_rid: contract_rid ?? null,
                    ksk_rid: ksk_rid ?? null,
                    user_id: user_id ?? null
                };
                commit('setparamSaved', param);
                const res = await prescriptionOZPService.getPrescriptionsObjectsOZP(param);
                commit('setPrescriptionsObjectsOZP', res.ahs_requests);
            } catch (e) {
                console.error(e);
            } finally {
                commit('setPrescriptionOZPLoading', false);
            }
        },
        async getEngineerObjectContractsList({ commit }, { icontract_rid, iengineer_rid }) {
            try {
                commit('setEngineerObjectContractsList', []);
                const res = await prescriptionOZPService.engineerObjectContractsList(icontract_rid, iengineer_rid);
                commit('setEngineerObjectContractsList', res.object_contracts);
            } catch (e) {
                console.error(e);
            } finally {
                //commit('setPrescriptionLoading', false);
            }
        },
        async getPrescriptionsOZPForExport(
            { state },
            { engineer_rid, contract_rid, ksk_rid, user_id, object_name, status_code_name, period_rid, prescription_number, boss, itemsPerPage, currentItem }
        ) {
            const param = {
                engineer_rid: engineer_rid ?? state.iengineer_rid ?? null,
                contract_rid: contract_rid ?? null,
                period_rid: period_rid ?? null,
                object_name: object_name ?? null,
                ksk_rid: ksk_rid ?? null,
                user_id: user_id ?? null,
                boss: boss ?? 0,
                status_code_name,
                prescription_number
            };

            const res = await prescriptionOZPService.getPrescriptionsOZP(itemsPerPage, currentItem, param);

            if (!Array.isArray(res?.ahs_requests)) {
                throw new Error('API не вернул массив ahs_requests');
            }

            return res.ahs_requests;
        }
    }
};
